import cortanaComposeStore from '../store/cortanaComposeStore';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setIsSuggesting', function setIsSuggesting(
    isSuggesting: boolean,
    queryString: string = ''
) {
    const viewState = cortanaComposeStore.viewState;
    viewState.isSuggesting = isSuggesting;
    viewState.isPopupShown = isSuggesting;

    if (!isSuggesting) {
        // Reset the viewState
        viewState.queryString = '';
    } else {
        if (queryString) {
            viewState.queryString = queryString;
        }
    }
});
